var React = require('react');

function Ita (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.31,29.84c-2.86-.29-5.46-2.77-5.86-5.6.79-6.14-2.97-16.62,5.81-18.07,5.28.69,14.32-2.31,16.87,4.06.55,1.37.69,4.31.49,5.77-.06.48-.72.72-1.07,1.05-2.77,2.57-5.44,6.66-9.72,6.35-1.14-.08-1.33-.71-1.7.72-.13.5-.1.88-.17,1.35-.04.32-.51.07-.71,0-.98-.37-2-1.42-2.33-2.41-.16-.47-.13-1.2-.25-1.46-.09-.21-.71-.64-.9-.91-3.07-4.29,6.21-10.04,10.11-6.94.99.79,1.3,1.45.2,2.31-1.52,1.21-7.3,2.63-6.73-.91-1.31.39-2.11,2.03-1.54,3.29.15.34.47.55.61.87-1.11,1.39-1.25,3.06-.13,4.49.11.14.93.96,1.05.81.27-4.98,7.06-4.27,8.83-8.09,1.53-3.31.04-7.78-3.93-8.22-9.06-1-16.85,15.39-7.33,19.18,4.91,1.95,8.53-.64,11.48-4.29,1.37-1.7,2.48-3.78,4.21-5.13v6.09c0,2.55-3.35,5.53-5.87,5.69-3.65-.27-7.85.36-11.44,0Z"}));
}

Ita.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 36 36"};

module.exports = Ita;

Ita.default = Ita;
